<div class="row">
    <div class="col-lg-12 grid-margin">
        <div class="card">
            <div class="card-body upper-header">
                <!-- <div class="row">
                    <div class="form-group col-2 ">
                        <label>From Date</label>
                        <input class="form-control border-primary" [max]="to_date" [owlDateTime]="dt" placeholder="Date"
                            name="from_date" [(ngModel)]="from_date" readonly>
                        <span [owlDateTimeTrigger]="dt" class="date-ico"><i class="fa fa-calendar"></i></span>
                        <owl-date-time #dt [pickerType]="'calendar'" [pickerMode]="'dialog'"></owl-date-time>
                    </div>
                    <div class="form-group col-2 ">
                        <label>To Date</label>
                        <input class="form-control border-primary" [min]="from_date" [max]="maxDate" [owlDateTime]="dt1"
                            placeholder="Date" name="to_date" [(ngModel)]="to_date" readonly>
                        <span [owlDateTimeTrigger]="dt1" class="date-ico"><i class="fa fa-calendar"></i></span>
                        <owl-date-time #dt1 [pickerType]="'calendar'" [pickerMode]="'dialog'"></owl-date-time>
                    </div>

                    <div class="form-group col-1.5">
                        <button type="button" style="margin-top: 30px;"
                            class="btn btn-primary btn-fw top-btn-head" (click)="getList($event)">Load</button>
                    </div>
                </div> -->
                <h4 class="card-title">
                    <div class="d-flex bd-highlight">
                        <div class="p-2 flex-grow-1 bd-highlight">Donation Pass Scans List</div>
                    </div>
                </h4>
                <div class="table-responsive"
                    *ngIf="scanList && scanList.data && scanList.data.length">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Name</th>
                                <th>Mobile No </th>
                                <th>Occasion</th>
                                <th>No of additional persons</th>
                                <th>Address</th>
                                <th>Total Scans</th>
                                <th>Donation Receipt</th>
                                <!-- <th>ID Card</th> -->
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of scanList?.data; let i = index">
                                <td>
                                    <span *ngIf="page == 1">{{i+1}}</span>
                                    <span *ngIf="page > 1">{{((page - 1 )*perPage) + (i+1)}}</span>
                                </td>
                                <td>{{data?.name}} </td>
                                <td>{{data?.mobile_no}}</td>
                                <td>{{data?.occasion}}</td>
                                <td>{{data?.no_of_additional_persons}}</td>
                                <td>{{data?.address}}</td>
                                <td>{{data?.total_scans}}</td>
                                <td>
                                    <a *ngIf="data.donation_receipt_url" title="Donation Receipt" class="ml-4" [href]="data.donation_receipt_url" target="_blank">
                    <i class="fa fa-download" style="font-size: 24px !important;" aria-hidden="true"></i>
                  </a>
                                </td>
                                <!-- <td>
                                    <a *ngIf="data.id_card_url" title="ID Card" [href]="data.id_card_url" target="_blank">
                    <i class="fa fa-download" style="font-size: 24px !important;" aria-hidden="true"></i>
                  </a>
                                </td> -->
                                <td style="text-align: center;">
                                    <a title="View" (click)="openInfoModal(data)">
                    <i class="fa fa-info" style="font-size: 18px !important;" aria-hidden="true"></i>
                  </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="p-12" *ngIf="scanList && scanList.data && !scanList.data.length">
                    <span class="ng-star-inserted no_data">No Data found.</span>
                </div>
                <ngb-pagination *ngIf="scanList && scanList.data && scanList.data.length" [collectionSize]="totalCount" [pageSize]="perPage"
                [page]="page" (pageChange)="getList('pagination')" class="pull-right justify-content-end page-mt-10"
          aria-label="Default pagination"></ngb-pagination>
            </div>
        </div>
    </div>
</div>

<!-- Certificate Preview Modal -->
<div
  class="modal fade show"
  *ngIf="showPreviewModal"
  style="display:block;background:rgba(0,0,0,.5)">

  <div class="modal-dialog modal-xl">
    <div class="modal-content">

      <div class="modal-header">
        <h5>Scans Details</h5>

        <button
          type="button"
          class="btn"
          (click)="CloseInfoModal()" style="padding: 5px; font-size: 13px;font-weight: 500;border: 2px solid #333;">
          X
        </button>
      </div>

      <div class="modal-body">

        <div class="certificate-wrapper">

          <div class="table-responsive"
                    >
                    <table class="table">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Scan Date</th>
                                <th>ID Card ID </th>
                                <th>Scanned By</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of scanData; let i = index">
                                <td>
                                    <span *ngIf="page == 1">{{i+1}}</span>
                                    <span *ngIf="page > 1">{{((page - 1 )* perPage) + (i+1)}}</span>
                                </td>
                                <td>{{ data?.scan_date | date:'dd/MM/yyyy' }} </td>
                                <td>{{data?.id_card_id}}</td>
                                <td>{{data?.scannedByUser?.username}}</td>
                                
                            </tr>
                        </tbody>
                    </table>
                </div>

        </div>

      </div>

    </div>

  </div>

</div>